/* 關張傳各章共用的小工具：史書上有名、但不是可選武將的人（嚴顏、關平……）、打不死的首領（生擒）、雨 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { H } from '../../heroes/define.ts';
import { troop } from '../kit.ts';

const NEUTRAL_C = { armor: '#5a4a3a', sleeve: '#3a3028', cloth: '#3a3028', trim: '#b8a060', pants: '#2a2420', boot: '#2a2018', cape: null, belt: '#5a3a22', metal: '#8e979f', hood: '#3a3028', pole: '#5a3a22', plume: '#b8a060', band: '#b8a060' };
const P = (id, name, sub, faction, role, weapon, look, skills) => H(id, name, sub, faction, role, weapon, Object.assign({ fx: '#ffd8a0' }, look, faction === 'neutral' ? { c: Object.assign({}, NEUTRAL_C, look.c) } : {}), skills);
const GEN = (a, b, c, d) => [['揮擊', 'crescent', `造成 {${a}/${a}/${a}/${a}} 傷害。`], ['衝陣', 'charge', `衝撞造成 {${b}/${b}/${b}/${b}} 傷害。`], ['迴斬', 'spin', `每圈 {${c}/${c}/${c}/${c}} 傷害。`], ['猛擊', 'slam', `{${d}/${d}/${d}} 傷害。`]];

export const GZ = {
  yanyan: P('yanyan', '嚴顏', '巴郡太守', 'neutral', '戰士', 'sword', { beard: 'long', hair: '#d8d4cc', eye: 'fierce', bulk: 1.1, c: { armor: '#5d6a78', cloth: '#3f4a56', cape: '#5d6a78', plume: '#9aa7b5' } }, GEN(110, 90, 50, 150)),
  guanping: P('guanping', '關平', '關羽之子', 'shu', '戰士', 'guandao', { beard: 'mustache', c: { cape: '#3e7b50' } }, GEN(80, 70, 40, 130)),
  zhaolei: P('zhaolei', '趙累', '都督', 'shu', '謀士', 'sword', { beard: 'goatee', head: 'guan' }, GEN(50, 40, 30, 80)),
  panzhang: P('panzhang', '潘璋', '孫權部將', 'wu', '戰士', 'sword', { eye: 'fierce', beard: 'bushy', bulk: 1.15 }, GEN(120, 100, 55, 170)),
  doctor: P('yi', '醫', '軍醫', 'neutral', '謀士', 'staff', { head: 'guan', beard: 'long', hair: '#9a948a', c: { armor: '#6a6050', cloth: '#5a5040' } }, GEN(10, 10, 10, 10)),
};
export const SOLDIER = {
  yizhou: troop('yizhou-soldier', '益州兵', { armor: '#5d6a78', sleeve: '#3f4a56', cloth: '#3f4a56', plume: '#9aa7b5' }), // 劉璋軍
};

// 生擒：這個首領打不死。血量要歸零時留一口氣、力屈被制住（u.subdued），由章節決定之後怎麼辦
export function spare(w, u, onDown) {
  if (w._spare) { w._spare.set(u, onDown); return; }
  w._spare = new Map([[u, onDown]]);
  const kill = w.kill;
  w.kill = function (src, t) {
    const f = w._spare.get(t);
    if (f && t.alive) { t.hp = 1; if (!t.subdued) { t.subdued = true; f(t); } return; }
    return kill.call(this, src, t);
  };
}
// 制住：不能被打、站著不動
export function hold(u) { u.untargetable = true; u.target = null; u.aggro = null; u.patrol = null; u.home = [u.x, u.y]; u.st.stun = Math.max(u.st.stun, 999); }

// 雨：斜斜的雨絲加一層灰（章節的 overlay 呼叫）
export function rain(ctx, view, x0, y0, vw, vh, k = 1) {
  const T = view.WS.time;
  ctx.save();
  ctx.fillStyle = `rgba(40,50,62,${(0.28 * k).toFixed(3)})`; ctx.fillRect(x0, y0, vw, vh);
  ctx.strokeStyle = `rgba(200,215,230,${(0.35 * k).toFixed(3)})`; ctx.lineWidth = 1.5; ctx.beginPath();
  const n = Math.round(160 * k);
  for (let i = 0; i < n; i++) {
    const sx = (i * 137.5) % vw, sy = (i * 71.3 + T * 900) % vh;
    ctx.moveTo(x0 + sx, y0 + sy); ctx.lineTo(x0 + sx - 8, y0 + sy + 26);
  }
  ctx.stroke(); ctx.restore();
}

// 潰逃的兵不再回頭打人（kit 的 rout 只清一次目標，creepAI 還會再挑）
export function calm(w) { for (const u of w.units) if (u.rout && u.alive) { u.target = null; u.think = 1; } }
